declare const STAGE: string;

export default {
	install: (app: any): void => {
		const rollbarConfig = {
			accessToken: '05a514d17aae4089827c098109c50988',
			captureUncaught: false,
			captureUnhandledRejections: false,
			checkIgnore: window['rollbarIgnore'],
			payload: {
				environment: STAGE,
			},
		};

		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		const rollbar =
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			window && window['rollbar'] && window['rollbarIgnore'] ? new window['rollbar'](rollbarConfig) : null;

		app.config.errorHandler = (error: any): void => {
			if (STAGE === 'prd') {
				// eslint-disable-next-line @typescript-eslint/no-unsafe-call
				rollbar.error(error);
			}

			throw error;
		};
	},
};
